// Enum for tax binder detail tabs
export enum TaxBinderTab {
  DocumentRequests = 'document-requests',
  ClientDocuments = 'client-documents',
  FirmDocuments = 'firm-documents',
  Questionnaire = 'questionnaire',
  Comments = 'comments',
  InternalNotes = 'internal-notes',
  Activity = 'activity',
  /** Superseded by {@link Activity}. Still accepted on read so saved links keep working. */
  AuditLog = 'audit-log',
  TaxReturns = 'tax-returns',
  Signatures = 'signatures',
  K1Distribution = 'k1-distribution',
}

// Narrows the K-1 Distribution tab to one kind of assignment
export enum K1PanelFilter {
  CarriedOver = 'carried-over',
}

// Map tab names to indices
export const TAB_INDEX_MAP: Record<TaxBinderTab, number> = {
  [TaxBinderTab.DocumentRequests]: 0,
  [TaxBinderTab.ClientDocuments]: 1,
  [TaxBinderTab.FirmDocuments]: 2,
  [TaxBinderTab.Questionnaire]: 3,
  [TaxBinderTab.Comments]: 4,
  [TaxBinderTab.InternalNotes]: 5,
  [TaxBinderTab.TaxReturns]: 6,
  [TaxBinderTab.Signatures]: 7,
  [TaxBinderTab.Activity]: 8,
  [TaxBinderTab.AuditLog]: 8,
  [TaxBinderTab.K1Distribution]: 9,
};

// Map indices to tab names
export const INDEX_TAB_MAP: Record<number, TaxBinderTab> = {
  0: TaxBinderTab.DocumentRequests,
  1: TaxBinderTab.ClientDocuments,
  2: TaxBinderTab.FirmDocuments,
  3: TaxBinderTab.Questionnaire,
  4: TaxBinderTab.Comments,
  5: TaxBinderTab.InternalNotes,
  6: TaxBinderTab.TaxReturns,
  7: TaxBinderTab.Signatures,
  8: TaxBinderTab.Activity,
  9: TaxBinderTab.K1Distribution,
};
